import { useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import TextoRico from '@/components/base/TextoRico';

interface DescricaoEventoProps {
  texto: string;
}

// Remove as tags para o resumo de 3 linhas (o texto completo, com formatação,
// abre logo abaixo com a altura animada).
function semTags(html: string): string {
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// Engrossa os trechos entre ** **, para o resumo não mostrar os asteriscos.
function comNegrito(linha: string) {
  return linha.split(/(\*\*[^*]+\*\*)/g).map((p, i) =>
    p.startsWith('**') && p.endsWith('**') && p.length > 4 ? (
      <strong key={i} className="font-semibold text-foreground-900">
        {p.slice(2, -2)}
      </strong>
    ) : (
      <span key={i}>{p}</span>
    ),
  );
}

// "Ler mais" abre o texto aqui mesmo, com a altura crescendo em 200 ms.
// Nenhum conteúdo muda: a formatação é a mesma da folha de antes.
export default function DescricaoEvento({ texto }: DescricaoEventoProps) {
  const [aberto, setAberto] = useState(false);
  if (!texto) return null;

  return (
    <div className="app-entra">
      <h2 className="text-[17px] font-extrabold text-foreground-950">Sobre o evento</h2>
      <p className="mt-2 line-clamp-3 text-[15px] leading-relaxed text-foreground-700">
        {comNegrito(semTags(texto))}
      </p>

      <AnimatePresence initial={false}>
        {aberto && (
          <motion.div
            key="texto-completo"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            className="overflow-hidden"
          >
            <TextoRico
              texto={texto}
              className="pt-2 text-[15px] leading-relaxed text-foreground-700"
            />
          </motion.div>
        )}
      </AnimatePresence>

      <button
        type="button"
        onClick={() => setAberto((a) => !a)}
        aria-expanded={aberto}
        className="aperta mt-1.5 cursor-pointer whitespace-nowrap text-[14px] font-bold text-primary-600"
      >
        {aberto ? 'Mostrar menos' : 'Ler mais'}
      </button>
    </div>
  );
}